import { FC } from "react";
import { IconProps } from "./types";

export const CheckMarkCircle: FC<IconProps> = ({
  fill = "#000",
  width = 24,
  height = 24,
  className,
  ...props
}) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    fill="none"
    viewBox="0 0 24 24"
    width={width}
    height={height}
    className={className}
    {...props}
  >
    <path
      xmlns="http://www.w3.org/2000/svg"
      fillRule="evenodd"
      clipRule="evenodd"
      d="M12 24c6.627 0 12-5.373 12-12S18.627 0 12 0 0 5.373 0 12s5.373 12 12 12zM5.214 12.938l4.754 4.753a.73.73 0 0 0 1.033 0l8.41-8.409a.732.732 0 0 0 0-1.034l-1.034-1.034a.732.732 0 0 0-1.034 0l-6.859 6.858-3.202-3.202a.732.732 0 0 0-1.034 0l-1.034 1.034a.732.732 0 0 0 0 1.034z"
      fill={fill}
    />
  </svg>
);
